import { useQuery } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { FolderItem } from 'api/types';

interface UseFoldersQueryParams {
  categoryId?: string;
}

export function useFoldersQuery({ categoryId }: UseFoldersQueryParams) {
  const { data, isLoading } = useQuery(
    ['allfolders', { category_id: categoryId }],
    () => API_HANDLERS.FOLDERS.GET_LIST({ category_id: categoryId, flat: true, path: true }),
    { enabled: !!categoryId },
  );

  return {
    folders: (data?.data ?? []) as FolderItem[],
    isLoading: !!categoryId && isLoading,
  };
}
